







































































import { Component, Prop, Vue } from "vue-property-decorator";
import { mapGetters } from "vuex";
 ;
import { User } from "@/types";

@Component({
    computed: { ...mapGetters(["user"]) },
    components: {},
})
export default class Messages extends Vue {

    private user!: User;

    async mounted() {

    }
    toGeneralSettings() {
        this.$router.push(`/${this.$i18n.locale}/user/${this.user.uid}/settings`);

        this.closeDropdown();
    }
    closeDropdown() {
        (this.$refs.dropdown as HTMLElement).click();
    }
}
